export default __webpack_public_path__ + "static/media/id-billing-logotype-d.aa39b6ed.svg";